import {
    Alert,
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
} from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { OpenDialog } from "event-definitions"
import { nanoid } from "nanoid"
import { successSnackbar } from "lib/snackbar/success-snackbar"

export function showCreatedTokenDialog(result, scimBaseUrl) {
    return new Promise((resolve) => {
        OpenDialog.raise({
            dialogProps: { maxWidth: "sm", fullWidth: true, boost: "boost" },
            dialogId: nanoid(),
            content: <CreatedTokenDialog result={result} scimBaseUrl={scimBaseUrl} />,
            resolve,
        })
    })
}

function CreatedTokenDialog({ result, scimBaseUrl, ok }) {
    return (
        <>
            <DialogTitle>SCIM token created</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ pt: 1 }}>
                    <Alert severity="warning">
                        Copy this token now. It is shown once and cannot be retrieved again. Revoke and create a new
                        token if you lose it.
                    </Alert>
                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            Prefix (for identification)
                        </Typography>
                        <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                            {result.prefix}…
                        </Typography>
                    </Box>
                    <TextField
                        label="Bearer token"
                        value={result.token}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            sx: { fontFamily: "monospace" },
                            endAdornment: (
                                <Button
                                    size="small"
                                    startIcon={<Iconify icon="mdi:content-copy" />}
                                    onClick={copyToken}
                                >
                                    Copy
                                </Button>
                            ),
                        }}
                    />
                    <Typography variant="body2" color="text.secondary">
                        Paste this token into your IdP's SCIM secret field. Set the Tenant URL to{" "}
                        <code>{scimBaseUrl || "https://your-sfg20-instance/scim/v2"}</code>.
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={ok} variant="contained">
                    Done
                </Button>
            </DialogActions>
        </>
    )

    function copyToken() {
        navigator.clipboard?.writeText(result.token).then(
            () => successSnackbar("Token copied to clipboard"),
            () => {}
        )
    }
}
